import { render } from "./AcceptApplicantDialog.vue?vue&type=template&id=4e608b0e"
import script from "./AcceptApplicantDialog.vue?vue&type=script&lang=js"
export * from "./AcceptApplicantDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__